import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    background: "#fff",
    borderRadius: 4,
  },
  visionWrapper: {
    background: "#fff",
    borderRadius: 12,
    "& .vision-profile-pic": {
      "&:after": {
        borderRadius: "50%",
      },
    },
  },
  cardSkeleton: {
    "& .react-loading-skeleton": {
      height: "100%",
    },
  },
  carouselSkeleton: {
    height: "calc(100% + 8px)",
    "& .MuiGrid-root": {
      height: "100%",
    },
  },
  gridSkeleton: {
    border: "1px solid #E1E4EA",
    borderRadius: 7,
    padding: "0 12px",
    marginBottom: 8,
    "& .react-loading-skeleton": {
      margin: "16px 0",
    },
  },
  myStorySkeleton: {
    "& .react-loading-skeleton": {
      margin: "16px 0",
    },
  },
  visionIcons: {
    "& span": {
      display: "flex",
      marginLeft: 10,
    },
  },
  unsplashSkeleton: {
    "& .react-loading-skeleton": {
      marginBottom: 8,
    },
  },
  teamKpi: {
    "& .react-loading-skeleton": {
      marginBottom: 16,
    },
  },
  LinkedTargetSkeleton: {
    "& .react-loading-skeleton": {
      marginBottom: 16,
    },
  },
  closeTargetSkeleton: {
    "& .react-loading-skeleton": {
      margin: "10px 0",
    },
  },
}));

export default useStyles;
